export default __webpack_public_path__ + "static/media/045-take public transport.387a8b42.svg";